import { FormattedMessage, useIntl } from 'react-intl';
import { EmptyState } from '@ets/design-system';

import styles from './RefStyleEmptyState.module.scss';

const RefStyleEmptyState = () => {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <EmptyState
        size="l"
        icon="folder"
        title={intl.formatMessage({ id: 'NO_REFERENCES_STYLES' })}
        description={<FormattedMessage id="TENANT_DOESNT_HAVE_REF_STYLES_UPLOADED" />}
        testId="no-references-styles"
      />
    </div>
  );
};

export default RefStyleEmptyState;
